module.exports = __webpack_public_path__ + "img/wallet_pc_05.b74ab1a2.png";